export default __webpack_public_path__ + "static/media/element_spec_15.b7373b61.jpg";